import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { AppCommonModule } from 'src/app/common.module';
import { SnapLink } from '../snap-links.component';


@Component({
  selector: 'app-snap-link',
  templateUrl: './snap-link.component.html',
  styleUrls: ['./snap-link.component.scss'],
  imports: [
    AppCommonModule,
    CommonModule,
  ],
})
export class SnapLinkComponent {

  @Input()
  item: SnapLink;
}
